









import { Vue, Component, Watch } from 'vue-property-decorator';
import { ContentPageViewModel } from '@/types/apiServerContract';
import { ContentApi } from '@/services/api/api.content';
import { HomePaths } from '@/core/constants';
import { Route } from 'vue-router';

@Component
export default class ContentPage extends Vue {
	loading: boolean = false;

	content: ContentPageViewModel | null = null;

	async getPageContent() {
	    if (this.loading) return;

	    this.loading = true;
	    this.content = null;

	    try {
	        const page = this.$route.path.replace('/page/', '');
	        const content = await ContentApi.GetContent(page);
	        this.content = content;
	    } catch (e) {
	        this.$router.push(HomePaths.News);
	    } finally {
	        this.loading = false;
	    }
	}

	@Watch('$route')
	onRouteChange(newRoute: Route, oldRoute: Route) {
	    if (newRoute.path !== oldRoute.path) {
	        this.getPageContent();
	    }
	}

	created() {
	    this.getPageContent();
	}
}
